import { createSlice } from "@reduxjs/toolkit";

import { TechnicalType } from "src/interfaces";
import { loadPeriodTypes as doLoadPeriodTypes } from "../services";
import { AppDispatch } from "../store";

const initialState = {
  isLoading: false,
  periodTypes: [] as TechnicalType[],
};

const NAME = "periodTypes";

const periodTypesSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    completeLoading: (state, action) => {
      state.isLoading = false;
      state.periodTypes = action.payload;
    },
    failLoading: (state) => {
      state.isLoading = false;
    },
  },
});

export const loadPeriodTypes = () => (dispatch: AppDispatch) => {
  dispatch(periodTypesSlice.actions.startLoading());
  const promise = doLoadPeriodTypes();
  promise
    .then((periodTypes) => {
      dispatch(periodTypesSlice.actions.completeLoading(periodTypes));
    })
    .catch(() => {
      dispatch(periodTypesSlice.actions.failLoading());
    });
  return promise;
};

export default periodTypesSlice.reducer;
